import React, {
    Component,
    Fragment,
} from 'react'
import classnames from 'classnames'
import Modal from '../../../components/modal'
import Button from '../../../front/components/shared/sn-button'
import Input from '../../../front/components/shared/sn-input'
import { i18n } from '../../../validator'

@i18n()
export default class addSport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            name: '',
            isSubmitted: false,
            busy: false,
        }
    }

    sportHandle = e => {
        this.setState({ name: e.target.value })
    }

    submitAddSport = () => {
        const {
            onSportSubmitted,
            t,
        } = this.props

        const {
            name,
            busy,
        } = this.state

        if (!name || name === '') {
            return window.swalert(t('sportBox.error.text'))
        }

        if (!busy) {
            this.setState({ busy: true })

            return window.axios.post(`${window.APP_CONFIG.REACT_APP_API_URL}api/sport-categories/create`, { name })
                .then(() => {
                    if (typeof onSportSubmitted === 'function') {
                        onSportSubmitted(name)
                    }

                    this.setState({
                        name: '',
                        isSubmitted: true,
                        busy: false,
                    })
                })
        }

        return null
    }

    render() {
        const {
            t,
            toggleModal,
        } = this.props

        const {
            name,
            isSubmitted,
            busy,
        } = this.state

        return (
            <Modal
                description={t('sportBox.modal.title')}
                handleHideModal={toggleModal}
                content={() => (
                    <div className="d-flex flex-column justify-content-center text-center p-4">
                        <h4>{t('sportBox.modal.contentTitle')}</h4>
                        <h5>{t('sportBox.modal.contentSubtitle')}</h5>

                        {!isSubmitted &&
                            <Fragment>
                                <Input
                                    type="text"
                                    value={name}
                                    onChange={this.sportHandle}
                                    className="form-control-lg"
                                    placeholder={t('sportBox.modal.inputSportNamePlaceholder')}
                                    maxLength="200"
                                />
                                <div className="d-flex flex-row flex-wrap justify-content-between">
                                    <Button
                                        className={classnames({
                                            'btn btn-color-gray-light-1 col-12 col-md-5 form-control': true,
                                            'btn-loading': busy,
                                        })}
                                        onClick={toggleModal}
                                    >
                                        {t('sportBox.modal.cancel')}
                                    </Button>
                                    <Button
                                        className={classnames({
                                            'btn btn-color-brand col-12 col-md-5': true,
                                            'btn-loading': busy,
                                        })}
                                        onClick={this.submitAddSport}
                                    >
                                        {t('sportBox.modal.confirm')}
                                    </Button>
                                </div>
                            </Fragment>
                        }

                        {isSubmitted &&
                            <div className="d-flex flex-column mt-4">
                                <div className="mt-2 mb-2">
                                    {t('sportBox.modal.successMessage')}
                                </div>
                                <Button
                                    className="btn btn-color-brand col-12 form-control"
                                    onClick={toggleModal}
                                >
                                    {t('sportBox.modal.successMessageCloseButtonText')}
                                </Button>
                            </div>
                        }

                    </div>
                )}
            />
        )
    }
}
